import React from 'react';
import {Button, Tooltip} from "antd";
import * as PropTypes from "prop-types";

export const Controls = props => <Button.Group id="controls">
  <Button key='1' icon='printer' onClick={() => window.print()}>Print</Button>
  {!props.tooltip
    ? <Button key='2' icon='download' onClick={props.pdfGenerator}>Download</Button>
    : <Tooltip title={props.tooltip}><Button key='2' icon='download'
                                             onClick={props.pdfGenerator}>Download</Button></Tooltip>}
</Button.Group>;

Controls.propTypes = {
  filename: PropTypes.string,
  pdfGenerator: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Reports/Controls.js